module.exports = __webpack_public_path__ + "img/snow.c1a6ac92.jpg";